import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div<{ prepend: boolean }>`
  margin-right: ${props => (props.prepend ? '0.5em' : 'none')};
`
export interface IconProps {
  icon: IconDefinition
  prepend?: boolean
}
export const Icon: React.FC<IconProps> = ({ icon, prepend = false }) => (
  <Wrapper prepend={prepend}>
    <FontAwesomeIcon icon={icon} />
  </Wrapper>
)
